import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const HomeViruses = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem py-5 py-md-5 py-lg-4 py-xl-5 p-topbottom2rem'>
            <Row className='d-flex justify-content-center'>
                <Col md='12' lg='4' className='img-w22 mt-md-4' style={{ backgroundSize:'contain', backgroundPosition:'center', backgroundRepeat:'no-repeat' ,backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/04/Home-page-Covid-Testing-Section-bg.png")', height:'auto', width:''}}>
                    <div className='p-4rem-2rem' style={{ padding:'',}}>
                    <div className=''  >
                        <text className='fs-ss-22 text-montserrat fw-700 text-white'>
                            <center>RSV / Influenza / Covid-19<br/>
                            and 19 Other Viruses<br/>
                            Testing Services<br/></center>
                        </text>
                    </div>
                    
                    <div className='flex-cent py-2 m-11rem-8rem' style={{ display:'flex',justifyContent:'center', marginLeft:''}}>
                        <img src='https://unitedlabcare.com/wp-content/uploads/2022/04/Home-page-Covid-Testing-Section-pic.png' alt='Covid Test' height='auto' width='' className='img-w21' />
                    </div>

                    <div className='flex-center'>
                        <Link to='/book-appointment' className=''>
                        <Button className='btn-ss-secondary rounded30' style={{ boxShadow:'1px 2px 8px 0 rgba(0,0,0,.3)'}}>
                            <text className='fw-600 text-montserrat fs-ss-14-2'>
                                Schedule Appointment
                            </text>
                        </Button>
                        </Link>
                    </div>
                    </div>
                </Col>

                <Col md='12' lg='8' className='pe-md-4 ps-lg-5 mt-md-5 mt-4 '>
                <div className='ps-lg-5 text-rtl'>
                    <div className='' style={{ textAlign:''}}>
                        <text className='fs-ss-36 text-montserrat text-ss-primary fw-700 lh-1-2'>
                            COVID-19, FLU, RSV <br/>
                            & 19 OTHER VIRUSES
                        </text>
                    </div>

                    <div className='me-md-0 me-3 mb-md-4' style={{ textAlign:''}}>
                        <text className='fs-ss-26-2 text-montserrat text-ss-black fw-700'>
                            Testing Center in Chicagoland
                        </text>
                    </div>

                    <div className='py-3' style={{ textAlign:'justify'}}>
                        <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'1px' }}>
                            To support your health, we provide various clinical lab tests. Get advantage of our Covid-19, flu, RSV, and 19 other viruses testing services without sitting in a waiting area.
                        </text>
                    </div>

                    <div className='py-3' style={{ textAlign:'justify'}}>
                        <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'1px' }}>
                            We are a top-tier Chicago testing facility focusing on expert solutions and testing services. We add value to society by enabling a better, safer, and more connected world. Moreover, one simple swab test can diagnose 19 different viruses within 24 hours. Our tests have an accuracy rate higher than 97%.
                        </text>
                    </div>

                    <Row className='mt-md-5 mt-3'>
                        <Col xs='6' sm='6' md='' className='flex-cent pb-md-0 pb-4'>
                            <div className='flex-center'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2022/04/Home-page-icon-1.png' alt='Walk-in Testing' height='auto' width='100px' />
                            </div>
                            <div className='flex-center'>
                                <text className='fs-ss-18 text-montserrat text-ss-black fw-700'>
                                    Walk-in <br/> Testing
                                </text>
                            </div>
                        </Col>

                         <Col xs='6' sm='6' md='' className='flex-cent pb-md-0 pb-4'>
                            <div className='flex-center'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2022/04/Home-page-icon-2.png' alt='Student & Staff Testing' height='auto' width='100px' />
                            </div>
                            <div className='flex-center'>
                                <text className='fs-ss-18 text-montserrat text-ss-black fw-700 lh-1-2'>
                                    <center>Student & <br/>Staff Testing</center>
                                </text>
                            </div>
                        </Col>

                         <Col xs='6' sm='6' md='' className='flex-cent pb-md-0 pb-4'>
                            <div className='flex-center'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2022/04/Home-page-icon-3.png' alt='In-office Testing' height='auto' width='100px' />
                            </div>
                            <div className='flex-center'>
                                <text className='fs-ss-18 text-montserrat text-ss-black fw-700 lh-1-2'>
                                    <center>In-office <br/>Testing</center>
                                </text>
                            </div>
                        </Col>

                         <Col xs='6' sm='6' md='' className='flex-cent pb-md-0 pb-4'>
                            <div className='flex-center'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2022/04/Home-page-icon-4.png' alt='Workplace Weekly Testing' height='auto' width='100px' />
                            </div>
                            <div className='flex-center'>
                                <text className='fs-ss-18 text-montserrat text-ss-black fw-700 lh-1-2'>
                                    <center>Workplace <br/>Weekly Testing</center>
                                </text>
                            </div>
                        </Col>
                    </Row>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default HomeViruses